import React from 'react';
// import FormControlLabel from '@material-ui/core/FormControlLabel';// import ConfTextField from './ConfTextField';
// import Checkbox from '@material-ui/core/Checkbox';
import C18MuiFormControlLabel from '../../usa/components/C18MuiFormControlLabel'
import C18MuiCheckbox from '../../usa/components/C18MuiCheckbox'
import {cl, globs} from '../../components/utils/utils';

class FuiCheckbox extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.mask=props?.custom?.mask||0xFF// bit mask
    this.props.getValue(props.ind, {type: "scalar"})
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
    // clear the in-flight-save lock on Save so subsequent controller-pushed
    // updates can refresh the checkbox without a page refresh. matches the
    // pattern in FUINumerical / VentStages / TimeOfDay / TextGeneral.
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent", this.savePageEvent)
    this.changed=false
  }

  componentWillUnmount=()=>{
    this.subscribe_updateFui.remove()
    this.subscribe_savePageEvent.remove()
  }

  updateFui=()=>{
    if(!this.changed){this.props.getValue(this.props.ind, {type: "scalar"})}
  }

  savePageEvent=()=>{
    this.changed=false
  }

  onChange=(e)=>{
    let val=+this.props.value
//     cl(val,e.target.checked)
    // invert: checked writes the "off" value (0), unchecked writes the "on" value (mask).
    // Used for inverted-label checkboxes like "Disable X" where the firmware field is 1=on/0=off.
    let checked=(this.props?.custom?.invert) ? !e.target.checked : e.target.checked
    if(this.props?.custom?.oneBit){// set one bit, or reset all
      val=(checked)?this.props?.custom?.oneBit:0
    }else{
      val=(checked) ? val|this.mask : val&~this.mask
    }
//     cl(val)
    this.props.onChange(this.props.ind,
      {value: val})
    this.changed=true// blocks updating
//     cl(val)
  }

  render(){
    let val=+this.props.value&this.mask
//     cl(this.props.value,val);
    let isChecked=(this.props?.custom?.invert) ? (val == 0) : (val != 0)
    return(
      <div id={this.props?.custom?.infoId} className="checkbox-field">
        <span><span className="override">
          <C18MuiCheckbox
            id="check"
            title={(this.props?.rest?.parent||(e=>{}))({uri:"pid",pr:this.props})}
            checked={isChecked}
            onChange={this.onChange}
            value="checkedB"
            color="primary"
            saveOK={this.props.saveOK}
          />
          <label>{this.props.title}</label></span>
        </span>
      </div>
    );
  }
}

  export default FuiCheckbox ;
